import generatedConfig from '../config/config.json';

export default {
    google_analytics_account: generatedConfig.google_analytics_account,
    google_maps_key: generatedConfig.google_maps_key,
};
